module.exports = __webpack_public_path__ + "img/newhomehero.fe913d63.png";